import type { Translate } from "@ui/providers/useTranslations";

import { formatFullName } from "@jti/fe-common";
import type { IUser } from "@jti/rest-api-types";

export const getFullUserName = (
  __: Translate,
  user: IUser | null,
  isSingleNameField: boolean,
  isReversedNameOrder: boolean
): string => {
  if (!user) return "";

  if (isSingleNameField) {
    const honorific = __("honorific", [], "");
    return `${user.last_name}${honorific}`;
  }

  return formatFullName(user.first_name, user.last_name, isReversedNameOrder);
};
